__turbopack_context__.v({
  "bottom": "header-module-scss-module__MR3eia__bottom",
  "headerImagePosition": "header-module-scss-module__MR3eia__headerImagePosition",
  "top": "header-module-scss-module__MR3eia__top",
});
